import { Post } from "../../types/objectContentTypes";

export const DummyPost: Post = {
  title: "Lorem Ipsum",
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  description_preview: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  message: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,",
  picture_orig: "https://static-media.fluxio.cloud/ricardo/ayS2ABJu.jpg",
  content_type: 'post',
  'created.unix': 0,
  'indexed.unix': 0,
  id: '',
  network: '',
  source: [''],
  sourceId: '',
  type: 'item',
  url: '',
  originUrl: '',
  slug: '',
  picture_medium: '',
  experience_order: 0,
  picture_large: '',
  "contacts.from": {
    ID: '',
    iname: '',
    source_id: '',
    name_full: '',
  },
  contacts: {
    from: {
      ID: '',
      iname: '',
      source_id: '',
      name_full: '',
    }
  },
}